export const TWITTER_WEB_INTENT_SHARE = 'https://twitter.com/intent/tweet'
export const FACEBOOK_WEB_INTENT_SHARE = 'https://www.facebook.com/dialog/share'
export const FACEBOOK_APP_ID = '1568543003276557'

export const GIFT_COUPON_URL = 'https://r.honeygain.me/sweetmoney'
export const PROMO_BANNER_IMAGE_URL = 'https://webassets.honeygain.com/uploads/2023/02/08154346/Invite-friends.svg'

export const GROWTHBOOK_API_HOST = 'https://ff.honeygain.com'
export const GROWTHBOOK_CLIENT_KEY = 'sdk-NZ1TpTSdEHH94Cg'
